import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAnonymous_uploadUnique_token_type = z.any()
export type TagsGetAnonymous_uploadUnique_token_type = z.infer<typeof tagsGetAnonymous_uploadUnique_token_type>

export const descriptionGetAnonymous_uploadUnique_token_type = z.any()
export type DescriptionGetAnonymous_uploadUnique_token_type = z.infer<typeof descriptionGetAnonymous_uploadUnique_token_type>

export const paramsGetAnonymous_uploadUnique_token_type = z.object({ "type": z.enum(["consumption","invoice"]) })
export type ParamsGetAnonymous_uploadUnique_token_type = z.infer<typeof paramsGetAnonymous_uploadUnique_token_type>

export const querystringGetAnonymous_uploadUnique_token_type = z.object({ "buildingId": z.string().uuid(), "collectionPointId": z.string().uuid().optional(), "submeterId": z.string().uuid().optional() })
export type QuerystringGetAnonymous_uploadUnique_token_type = z.infer<typeof querystringGetAnonymous_uploadUnique_token_type>

export const responseGetAnonymous_uploadUnique_token_type = z.object({ "payload": z.object({ "token": z.string() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAnonymous_uploadUnique_token_type = z.infer<typeof responseGetAnonymous_uploadUnique_token_type>

interface IGetAnonymous_uploadUnique_token_type extends BaseMethodType {
  tags: TagsGetAnonymous_uploadUnique_token_type,
  description: DescriptionGetAnonymous_uploadUnique_token_type,
  params: ParamsGetAnonymous_uploadUnique_token_type,
  querystring: QuerystringGetAnonymous_uploadUnique_token_type,
  response: ResponseGetAnonymous_uploadUnique_token_type
}
export const URL = '/anonymous-upload/unique-token/:type'
export const validation = {
  get: {
    tags: tagsGetAnonymous_uploadUnique_token_type,
    description: descriptionGetAnonymous_uploadUnique_token_type,
    params: paramsGetAnonymous_uploadUnique_token_type,
    querystring: querystringGetAnonymous_uploadUnique_token_type,
    response: responseGetAnonymous_uploadUnique_token_type
  }
}
export interface Anonymous_uploadUnique_token_type extends BaseRouteType {
  get: IGetAnonymous_uploadUnique_token_type
}